export const handlePriceByComma = (price) => {
  return new Intl.NumberFormat("en-US").format(Math.floor(price));
};
